import { useReactiveVar } from '@apollo/client';
import { useCallback, useState } from 'react';

import { headerStateProps } from '@/services/apollo/vars';

import useThemeState from './useThemeState';

const useHeaderState = () => {
	const { showHeader, showBackground } = useReactiveVar(headerStateProps);

	const { setTheme, isDarkMode, theme: themeMode } = useThemeState();

	const [isChecked, setIsChecked] = useState(false || isDarkMode());

	const setShowBackground = useCallback(
		(newBackground: boolean) => {
			headerStateProps({
				showHeader,
				showBackground: newBackground,
			});
		},
		[showHeader]
	);

	const setShowHeader = useCallback(
		(newHeader: boolean) => {
			headerStateProps({
				showHeader: newHeader,
				showBackground,
			});
		},
		[showBackground]
	);

	return {
		showHeader,
		showBackground,
		setShowHeader,
		setShowBackground,
		isChecked,
		setIsChecked,
	};
};

export default useHeaderState;
